import { render, staticRenderFns } from "./ExerciseShow.vue?vue&type=template&id=2356470c&scoped=true&"
import script from "./ExerciseShow.vue?vue&type=script&lang=js&"
export * from "./ExerciseShow.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseShow.vue?vue&type=style&index=0&id=2356470c&lang=scss&scoped=true&"
import style1 from "./ExerciseShow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356470c",
  null
  
)

export default component.exports